<template>
  <a-card :bordered="false">
    <s-table size="default" :columns="columns" :data="loadData">
      <template slot="pic" slot-scope="text">
        <span class="pic"><img :src="text" /></span>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getBuydetail } from "@/api/purchase";

export default {
  name: "AllocationRecordDetail",
  components: {
    STable,
  },
  data() {
    return {
      mdl: [],
      columns: [
        {
          title: "SKU",
          dataIndex: "sku",
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
        },
        {
          title: "调拨数量",
          dataIndex: "quantity",
        },
      ],
      loadData: (params) => {
        return getBuydetail({ ...params, id: this.$route.params.id }).then(
          (res) => res
        );
      },
    };
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
